export const PREFIX = 'MD-STOP-LOSS-CONTRACT_';

export const SEARCH_REFRESH = PREFIX + 'SEARCH_REFRESH';
